// extracted by mini-css-extract-plugin
module.exports = {"Error":"ErrorBoundary_Error__3522x","ErrorContent":"ErrorBoundary_ErrorContent__3iwvF"};